import React from 'react';
import { Card, Skeleton, Row, Col } from 'antd';

interface ContentSkeletonProps {
  cardCount?: number;
  rows?: number;
  hasTable?: boolean;
}

const ContentSkeleton: React.FC<ContentSkeletonProps> = ({
  cardCount = 4,
  rows = 3,
  hasTable = false,
}) => {
  return (
    <div style={{ animation: 'fadeIn 0.5s ease-out' }}>
      <Skeleton.Input
        style={{ width: 200, marginBottom: 24 }}
        active
        size="large"
      />
      
      <Row gutter={[16, 16]}>
        {Array(cardCount).fill(null).map((_, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <Card style={{ 
              animation: `fadeInUp 0.5s ease-out ${index * 0.1}s`,
              height: '100%' 
            }}>
              <Skeleton active paragraph={{ rows: 1 }} />
            </Card>
          </Col>
        ))}
      </Row>

      {hasTable && (
        <Card style={{ marginTop: 16, animation: 'fadeInUp 0.5s ease-out 0.4s' }}>
          <Skeleton.Input
            style={{ width: 150, marginBottom: 16 }}
            active
            size="small"
          />
          <Skeleton active paragraph={{ rows }} />
        </Card>
      )}

      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(40px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .ant-skeleton {
            display: block;
          }

          .ant-skeleton-element {
            display: inline-block;
          }
        `}
      </style>
    </div>
  );
};

export default ContentSkeleton;
